const E = {
  'I Agree to the Terms and Conditions': 'I Agree to the Terms and Conditions',
  Continue: 'Continue',
  Decline: 'Decline',
  Accept: 'Accept',
  'Back to': 'Back to',
  title: 'Customer Portal - Terms and Conditions of Use',
};

const F = {
  'I Agree to the Terms and Conditions': 'J’accepte les modalités d’utilisation',
  Continue: 'Continuer',
  Decline: 'Refuser',
  Accept: 'Accepter',
  'Back to': 'Retour',
  title: 'Modalités d’utilisation du portail client',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/terms.js